module.exports = __webpack_public_path__ + "static/img/chart-pic2.a4426c63.png";